import React from 'react'
import { whatsapp } from '../../assets'
import {ImageBuffer} from '../'

import './customerSupport.css'

const CustomerSupport = () => {
    const whatsappNumber = "7040333675";
    const whatsappMessage = encodeURIComponent(
        "From OluwaSanmi Hub, i want need to make an enquiry on..."
    );
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
        <div className='customer-support-wrapper'>
            <small>Contact</small>

            <a
                href={`${whatsappLink}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span>
                    <ImageBuffer src={whatsapp} alt='contact us' />
                </span>
            </a>
            
        </div>
    </>
  )
}

export default CustomerSupport